import React from 'react';
export function Footer() {
  return <footer className="bg-[#030610] py-5 md:py-8 px-4 sm:px-6 lg:px-8 border-t border-primary-card text-center" data-id="element-70">
      <div className="max-w-7xl mx-auto" data-id="element-71">
        <p className="text-sm md:text-base text-text-muted font-medium mb-1 md:mb-2" data-id="element-72">
          GUIADIGITAL360 ™ | Química Aplicada © 2026. Todos los derechos
          reservados.
        </p>
        <p className="text-xs text-text-muted/50 max-w-2xl mx-auto" data-id="element-73">
          Este sitio no es parte del ecosistema de Meta o Facebook Inc.
        </p>
      </div>
    </footer>;
}